import { AlertOutlined } from '@ant-design/icons';

import { SocialIntegrationsWarningModal } from '@app/components/Modals';
import { SidebarBanner } from '@app/shared/components/SidebarBanner';
import {
  useSocialIntegrationsWarning,
  useSocialIntegrationsWarningEffects,
} from '@app/shared/components/SocialIntegrationsWarning/hooks';

import type { FC } from 'react';

interface SocialIntegrationsWarningProps {
  isSmall?: boolean;
}

export const SocialIntegrationsWarning: FC<SocialIntegrationsWarningProps> = ({
  isSmall,
}) => {
  const {
    openModal,
    hasErrors,
    countErrors,
    errorIntegrations,
    isSnoozed,
    snoozeMenu,
    openIntegration,
    closeModalHandler,
    wsChangeHandler,
    restoreStatusFromCache,
  } = useSocialIntegrationsWarning();

  useSocialIntegrationsWarningEffects({
    onRestoreStatus: restoreStatusFromCache,
    onWsChange: wsChangeHandler,
  });

  if (!hasErrors || isSnoozed) return null;

  return (
    <>
      <SidebarBanner
        variant="danger"
        icon={<AlertOutlined />}
        title="Сбои интеграций"
        subtitle={`Ошибок: ${countErrors}`}
        isSmall={isSmall}
        closeMenu={snoozeMenu}
        closeAriaLabel="Скрыть предупреждение"
        dataTestId="social-integrations-warning"
        onClick={openIntegration}
      />
      <SocialIntegrationsWarningModal
        open={openModal}
        onClose={closeModalHandler}
        integrations={errorIntegrations}
      />
    </>
  );
};
